import TranslationProvider from "./contexts/TranslationContext";
import WindowDimensionsProvider from "./contexts/WindowDimensionsContext";
import CounterProvider from "./contexts/CounterContext";
import AuthProvider from "./contexts/AuthContext";
import MyRoutes from "./MyRoutes";
import {BrowserRouter} from "react-router-dom";
import 'react-toastify/dist/ReactToastify.css';
import './css/constants.css'
import {ConfigProvider} from "antd";
import locale from 'antd/locale/fr_FR';
import dayjs from 'dayjs';
import 'dayjs/locale/fr';

export function App() {
    dayjs.locale('fr');

    return (
        <BrowserRouter>
            <ConfigProvider locale={locale}>
                <TranslationProvider>
                        <AuthProvider>
                            <WindowDimensionsProvider>
                                    <CounterProvider>
                                        <MyRoutes/>
                                    </CounterProvider>
                            </WindowDimensionsProvider>
                        </AuthProvider>
                </TranslationProvider>
            </ConfigProvider>
        </BrowserRouter>
    );
}

export default App;
